import listTemplate from "../../../templates/listTemplate";
import ExportLinkType from "../../../utils/services/project/accounting/exportLinkTypeService";
let list = listTemplate(ExportLinkType);

const state = {
  ...list.state
};
const getters = {
  ...list.getters
};

const actions = {
  ...list.actions
};

const mutations = {
  ...list.mutations
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
